import { Component, Element, Event, EventEmitter, h, Host, Listen, Prop, State, Watch } from "@stencil/core";
import { limitSlotElements } from "../../../utils/limitSlotElements";

@Component({
    tag: "ux-table-row-neo",
    styleUrls: ["table-row-neo.scss"],
    shadow: true
})
export class TableRowNeo {
    @Element() host!: HTMLUxTableRowNeoElement;

    /**
     * Set table row to loading state. All child cells will be loading.
     */
    @Prop({ reflect: true }) readonly loading: boolean;

    /**
     *
     */
    @Prop() readonly selectable: boolean;

    componentDidLoad() {
        limitSlotElements(this.host, {
            allowed: {
                default: ["ux-table-row-neo"]
            }
        });
    }

    /**
     * Cell count change event
     * @internal
     */
    @Event() cellCountChange!: EventEmitter<number>;

    /**
     * Head cell count change event
     * @internal
     */
    @Event() headCellCountChange!: EventEmitter<number>;

    /**
     * The cells in the row.
     */
    @State() cells: Node[];

    /**
     * If true, the row will be rendered as a header row.
     */
    @Prop() readonly head: boolean;

    private handleSlotChange(e: HTMLSlotElement | null) {
        if (!e) {
            return;
        }
        this.cells = (e as HTMLSlotElement).assignedNodes().filter((item) => item.nodeName.toLowerCase() !== "#text");
        this.host.style.setProperty("--ux-cell-count", this.cells.length.toString());
        if (this.head) {
            this.headCellCountChange.emit(this.cells.length);
        } else {
            this.cellCountChange.emit(this.cells.length);
        }
        for (const [index, cell] of this.cells.entries()) {
            (cell as HTMLUxTableCellNeoElement).index = index;
        }
    }

    @Listen("uxSort")
    clearSortFields(event: CustomEvent) {
        this.cells.forEach((cell) => {
            if (cell.isEqualNode(event.target as Node)) {
                return;
            }
            (cell as HTMLUxTableCellNeoElement).removeAttribute("sorted");
        });
    }

    @Watch("loading")
    setLoadingState(enabled: boolean = this.loading) {
        const cells = Array.from(this.host.querySelectorAll<HTMLUxTableRowNeoElement>("ux-table-cell-neo"));
        const headCells = Array.from(this.host.querySelectorAll<HTMLUxTableRowNeoElement>("ux-table-cell-neo[head]"));
        for (const cell of [...cells, ...headCells]) {
            cell.loading = enabled;
        }
    }

    render() {
        return (
            <Host role="row">
                {this.selectable ? <ux-table-ux-table-cell-neo> </ux-table-ux-table-cell-neo> : null}
                <slot onSlotchange={(e) => this.handleSlotChange(e.target as HTMLSlotElement)} />
            </Host>
        );
    }
}
